/** @domain identity -- Personal identity credentials: email, SSN, tax ID, username. */
import { z } from 'zod';
import { createDomainField } from './types';
import { maskTaxId } from './formatters';

const define = createDomainField('identity');

// ---------------------------------------------------------------------------
// Field definitions
// ---------------------------------------------------------------------------

export const email = define({
  label: 'Email',
  schema: z.string().email('Must be a valid email address'),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const ssn = define({
  label: 'SSN',
  hint: 'Social Security Number',
  schema: z.string(),
  adapterHint: 'password',
  displayFormat: 'ssn',
});

export const taxId = define({
  label: 'Tax ID (EIN)',
  placeholder: 'XX-XXXXXXX',
  hint: 'Employer Identification Number',
  schema: z.string().regex(/^\d{2}-\d{7}$/, 'Must be in XX-XXXXXXX format'),
  adapterHint: 'text',
  formatter: maskTaxId,
  displayFormat: 'ssn',
});

export const username = define({
  label: 'Username',
  placeholder: 'Enter username',
  schema: z
    .string()
    .min(4, 'Must be at least 4 characters')
    .max(200, 'Must be at most 200 characters')
    .regex(/^[A-Za-z]/, 'Must not start with a number')
    .regex(/^[A-Za-z0-9].*[A-Za-z0-9]$|^[A-Za-z0-9]{2}$/, 'Must not start or end with special characters')
    .refine((v) => !/\s/.test(v), 'Must not contain spaces')
    .refine((v) => !/^[0-9]+$/.test(v), 'Must not contain only numbers'),
  adapterHint: 'text',
  displayFormat: 'text',
});
